import { CreateUIAnalyticsEvent } from "@atlaskit/analytics-next";

declare global {
    interface Window {
        dataLayer?: (Record<string, unknown> | [string, string, unknown])[];
        OnetrustActiveGroups?: string;
        cmsPageVariant?: string;
        isUniform?: boolean;
        compositionStatusCode?: number;
        ga: (command: string, ...args: unknown[]) => void;
        analyticsPageReady?: () => void;
        metricsReady?: () => void;
    }
}

export class AnalyticsState {
    public static anonymousId: string | null;
    public static pageViewOptions: Record<string, unknown>;
    public static utms: Record<string, string> | null;
    public static version: string | null;
    public static writeKey: string | null;
    public static createAnalyticsEvent: CreateUIAnalyticsEvent | null;
}
